module.exports = __webpack_public_path__ + "static/media/20ECE26.ce513e8d.jpg";